const config = {
    CHATSERVER_URL: 'https://api.edg.com.au/murphybot/chatserver',
    HEADER_TEXT: "BWS Bot",
    ARTICLE_TEXT: "Help",
    TICKET_FORM_HEADER_TEXT: "Contact Us",
    MESSAGE_SENT: "Message Sent",
    ZENDESK_FORM_ID: "",
    DAN_HELP_CENTRE_URL: "https://wowbws.zendesk.com/hc/en-us",
    DAN_CONTACT_US_FORM_URL: "https://www.bws.com.au/contact?source=bot",
    ENDEAVOUR_DELIVERY_URL: "https://endeavourdelivery.com.au/track?search=",
    AUSPOST_URL: "https://auspost.com.au/mypost/track/#/details/",
    FRIENDLY_ERROR_MESSAGE: "Sorry but I’m having some technical issues. I’ll be back shortly",
    IDLE_MESSAGE: "Looks like you don't need any more help! I'm going to leave you alone now. I'm still here if you need me. You can close the chat window to end our chat or ask me another question.",
    IDLE_MESSAGE_FOLLOW: "Ask another question",
    IDLE_TIMEOUT: 1000 * 60 * 10,
    SESSION_ALIVE_PING: 1000 * 60 * 8,
    AUTOEND_TIMEOUT: 1000 * 60 * 5,
    COOKIES_CHATBOT_USER_ID_TEXT: "chatbotUserId",
    COOKIES_ARTICLE_TOKEN_TEXT: "chatbotLCArticleToken",
    COOKIES_LIVECHAT_SESSION: "chatbotDMSession",
    TRACK_ORDER_EMPTY_STATUS: "Please click the link below to view more details",
    ZENDESK_LIVECHAT_DEPARTMENT_ID : '',
    ZENDESK_LIVECHAT_GROUP_ID : '',
    ZENDESK_CHAT_CONNECTION : '',
    COOKIE_DOMAIN : 'prdedgccslivraue.z8.web.core.windows.net',
    APIMGT_KEY: '7eb95db69b8a4a3a85ca9eb9a52e43b8',
    FACEBOOK_CLOSE_WINDOW_URL: "https://www.messenger.com/closeWindow/?image_url=''&display_text=Closing%20window",
    ALLOWED_CHARACTERS: /^[a-zA-Z0-9?*!:.,$%#_\\-\\~\\ô\\&\\+\\ö\\é\\è\\(\\)\\/\\'\\%\\ñ\\:\\ô\\"\\@\\â\\ë\\á\\Ä\\°\\â\\«\\»\\ö\\ò\\É\\É\\’\s`]+$/,
    ISSTAGING: false,
    SOURCE: isWebView() ? 'bwsapp' : 'bws',
    ISWEBVIEW : isWebView(),
    APPCLOSEURL : 'https://bot.close/?i_cid=bwsbot',
    BWS_MY_ACCOUNT_URL : 'https://bws.com.au/my-account'
}

function isWebView() {
    const params = new URL(document.location.toString()).searchParams;
    const webview  = params.get("webview");

    return Boolean(webview);
}

export {
    config
}